import styled from "styled-components";

export const StyledDebtSummaryHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.darkBlue};
`;
